import { render, staticRenderFns } from "./ModelosImpressao.vue?vue&type=template&id=f5f4b52c&scoped=true"
import script from "./ModelosImpressao.vue?vue&type=script&lang=js"
export * from "./ModelosImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4b52c",
  null
  
)

export default component.exports